// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3pcBg","alertIcon":"ConfirmModal_alertIcon__1XBkL"};